<template>
  <div class="data-page">
     <Tabs type="card">
      <!-- <TabPane class="data-pane" :label="$t('data.Device.output')">
        <Form class="edit-form" :label-width="100" inline>
          <FormItem :label="$t('data.Device.name')">
            <Select class="info collectorSelect" v-model="collectorID" :value="collectorID" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Device.please_enter')}}</Option>
              <Option v-for="item in collectorList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('data.Device.group')">
            <Select class="info collectorSelect" v-model="groupname" :value="groupname" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Device.please_enter')}}</Option>
              <Option v-for="item in group" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem> -->
          <!-- <FormItem label="时间范围">
            <DatePicker class="info daterange" type="daterange" @on-change="dateChange" :value="selectTime" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem> -->
          <!-- <FormItem :label="$t('data.Device.start_date')">
            <DatePicker class="info" @on-change="entryTimeChange1" :value="selectTime1" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem>
          <FormItem :label="$t('data.Device.end_date')">
            <DatePicker class="info" @on-change="entryTimeChange2" :value="selectTime2" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem>
          <Button type="primary" @click="getData(1)">{{$t('data.Device.ok')}}</Button>
          <Button type="primary" @click="exportData(1)"><Icon type="ios-download-outline"></Icon>{{$t('data.Device.out')}}</Button>
        </Form>
        <Table class="device-data-table" highlight-row stripe border :columns="deviceColumns1" :data="datas1" ref="table1"></Table>
      </TabPane> -->
      <TabPane class="data-pane" :label="$t('data.Device.status')">
        <Form class="edit-form" :label-width="100" inline>
          <FormItem :label="$t('data.Device.name')">
            <Select class="info collectorSelect" v-model="collectorID" :value="collectorID" @on-change="collectorSelectChange" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Device.please_enter')}}</Option>
              <Option v-for="item in collectorList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label="$t('data.Device.group')">
            <Select class="info collectorSelect" v-model="groupname" :value="groupname" @on-change="collectorGroupSelectChange" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Device.please_enter')}}</Option>
              <Option v-for="item in grouplist" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem :label="$t('data.Order.orderNo')">
            <Select class="info collectorSelect" v-model="orderID" :value="orderID" filterable>
              <Option :value="Number(0)" :key="Number(0)">{{$t('data.Order.please_enter')}}</Option>
              <Option v-for="item in orderList" :value="item.orderID" :key="item.orderID">{{ item.orderNo }}</Option>
            </Select>
          </FormItem> -->
          <!-- <FormItem label="时间范围">
            <DatePicker class="info daterange" type="daterange" @on-change="dateChange" :value="selectTime" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem> -->
          <FormItem :label="$t('data.Device.start_date')">
            <DatePicker @on-change="entryTimeChange1" :value="selectTime1" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem>
          <FormItem :label="$t('data.Device.end_date')">
            <DatePicker @on-change="entryTimeChange2" :value="selectTime2" :placeholder="$t('data.Device.please_enter_date')"></DatePicker>
          </FormItem>
          <Button type="primary" @click="getData(2)">{{$t('data.Device.ok')}}</Button>
          <Button type="primary" @click="exportData(2)"><Icon type="ios-download-outline"></Icon>{{$t('data.Device.out')}}</Button>
        </Form>
        <Table class="device-data-table" highlight-row stripe border :columns="deviceColumns2" :data="datas2" :loading="loading" ref="table2"></Table>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import {Api} from '@/api'

export default {
  name: 'Plan',
  data () {
    return {
      orderID: 0,
      collectorList: [],
      collectorID: 0,
      // selectTime: [],
      selectTime1: '',
      selectTime2: '',
      deviceColumns1: [
        { title: this.$t('data.Device.name'), key: 'name', sortable: true, sortType: 'asc' },
        { title: this.$t('data.Device.date'), key: 'date', sortable: true },
        { title: this.$t('data.Device.group'), key: 'group', sortable: true },
        { title: this.$t('data.Device.output'), key: 'output' },
        { title: this.$t('data.Device.unit'), key: 'unit' }
      ],
      deviceColumns2: [
        { title: this.$t('data.Device.name'), key: 'name', sortable: true, sortType: 'asc' },
        { title: this.$t('data.Device.group'), key: 'group', sortable: true },
        { title: this.$t('data.Device.date'), key: 'date' },
        // { title: '货号', key: 'deviceType' },
        { title: this.$t('data.Device.runTotalTime'), key: 'runTotalTime' },
        { title: this.$t('data.Device.stopTime'), key: 'stopTime' },
        { title: this.$t('data.Device.stopTotalTime'), key: 'stopTotalTime' },
        { title: this.$t('data.Device.error1Time'), key: 'error1Time' },
        { title: this.$t('data.Device.error1TotalTime'), key: 'error1TotalTime' },
        { title: this.$t('data.Device.error2Time'), key: 'error2Time' },
        { title: this.$t('data.Device.error2TotalTime'), key: 'error2TotalTime' },
        { title: this.$t('data.Device.error3Time'), key: 'error3Time' },
        { title: this.$t('data.Device.error3TotalTime'), key: 'error3TotalTime' },
        { title: this.$t('data.Device.error4Time'), key: 'error4Time' },
        { title: this.$t('data.Device.error4TotalTime'), key: 'error4TotalTime' }
      ],
      orderDatas: [],
      datas1: [],
      datas2: [],
      group: [],
      grouplist: [],
      orderList: [],
      groupname: 0,
      worktime: '',
      loading: false
    }
  },
  methods: {
    getData (tp) {
      let time2 = this.selectTime2
      let time1 = this.selectTime1
      if (time1 === '' || time2 === '') {
        const title = this.$t('Order.error')
        const content = this.$t('data.Device.please_enter_date')
        this.$Modal.error({
          title: title,
          content: content
        })
        return
      }
      this.selectTime2 = new Date(new Date(this.selectTime2).getTime() + 1 * 24 * 60 * 60 * 1000)
      this.selectTime2 = this.selectTime2.getFullYear() + '-' + (this.selectTime2.getMonth() + 1) + '-' + this.selectTime2.getDate()
      this.selectTime1 = this.selectTime1 + ' ' + this.worktime
      this.selectTime2 = this.selectTime2 + ' '
      let collectors = []
      if (this.groupname !== 0) {
        for (let i = 0; i < this.grouplist.length; i++) {
          if (this.groupname === this.grouplist[i].id) {
            collectors = this.grouplist[i].collectors
          }
        }
      } else if (this.collectorID !== 0) {
        collectors.push(this.collectorID)
      }
      let req = {collectorID: collectors, startTime: this.selectTime1, endTime: this.selectTime2}
      // console.log(req)
      this.selectTime2 = time2
      this.selectTime1 = time1
      let ss = this.$t('data.Device.S')
      let mm = this.$t('data.Device.M')
      let hh = this.$t('data.Device.H')
      let dd = this.$t('data.Device.D')
      function formatSeconds (value) {
        var theTime = parseInt(value) // 需要转换的时间秒
        var theTime1 = 0 // 分
        var theTime2 = 0 // 小时
        var theTime3 = 0 // 天
        if (theTime > 60) {
          theTime1 = parseInt(theTime / 60)
          theTime = parseInt(theTime % 60)
          if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60)
            theTime1 = parseInt(theTime1 % 60)
            if (theTime2 > 24) {
              // 大于24小时
              theTime3 = parseInt(theTime2 / 24)
              theTime2 = parseInt(theTime2 % 24)
            }
          }
        }
        var result = ''
        if (theTime >= 0) {
          result = '' + parseInt(theTime) + ss
        }
        if (theTime1 > 0) {
          result = '' + parseInt(theTime1) + mm + result
        }
        if (theTime2 > 0) {
          result = '' + parseInt(theTime2) + hh + result
        }
        if (theTime3 > 0) {
          result = '' + parseInt(theTime3) + dd + result
        }
        return result
      }
      let datalist = {}
      let Sumhead = ['error1Time', 'error2Time', 'error3Time', 'error4Time', 'stopTime']
      let Timehead = ['error1TotalTime', 'error2TotalTime', 'error3TotalTime', 'error4TotalTime', 'runTotalTime', 'stopTotalTime']
      let Temp = ['error1', 'error2', 'error3', 'error4', 'run', 'stop']
      let name = []
      this.datas2 = []
      this.loading = true
      Api.data.collectorData(tp, req).then(res => {
        this.loading = false
        if (!res.datas) {
          return
        }
        for (let i = 0; i < res.datas.length; i++) {
          if (datalist[res.datas[i].collectorID] === undefined) {
            datalist[res.datas[i].collectorID] = {}
            name[res.datas[i].collectorID] = res.datas[i].name
          }
          let d = datalist[res.datas[i].collectorID]
          if (d[res.datas[i].Date] === undefined) {
            d[res.datas[i].Date] = {}
            for (let j = 0; j < Sumhead.length; j++) {
              d[res.datas[i].Date][Sumhead[j]] = 0
            }
            for (let j = 0; j < Timehead.length; j++) {
              d[res.datas[i].Date][Timehead[j]] = 0
            }
            d[res.datas[i].Date].Temp = {}
            for (let j = 0; j < Temp.length; j++) {
              d[res.datas[i].Date].Temp[Temp[j]] = 0
            }
          }
          if (res.datas[i].type === 2 || res.datas[i].type === 7) {
            if (res.datas[i].type === 2) {
              d[res.datas[i].Date].stopTime++
            }
            if (d[res.datas[i].Date].Temp['stop'] === 0) {
              d[res.datas[i].Date].Temp['stop'] = res.datas[i].record
            }
            if (d[res.datas[i].Date].Temp['run'] !== 0) {
              d[res.datas[i].Date]['runTotalTime'] += (res.datas[i].record - d[res.datas[i].Date].Temp['run'])
              d[res.datas[i].Date].Temp['run'] = 0
            }
          }
          if (res.datas[i].type === 1 || res.datas[i].type === 8) {
            if (d[res.datas[i].Date].Temp['run'] === 0) {
              d[res.datas[i].Date].Temp['run'] = res.datas[i].record
            }
            if (d[res.datas[i].Date].Temp['stop'] !== 0) {
              d[res.datas[i].Date]['stopTotalTime'] += (res.datas[i].record - d[res.datas[i].Date].Temp['stop'])
              d[res.datas[i].Date].Temp['stop'] = 0
            }
          }
          // console.log(res.datas[i])
          for (let j = 0; j < 4; j++) {
            if ((res.datas[i].type === 3) && ((res.datas[i].code & (1 << j)) !== 0)) {
              d[res.datas[i].Date][Sumhead[j]]++
            }
            if ((res.datas[i].type === 3 || res.datas[i].type === 5) && ((res.datas[i].code & (1 << j)) !== 0)) {
              if (d[res.datas[i].Date].Temp[Temp[j]] === 0) {
                d[res.datas[i].Date].Temp[Temp[j]] = res.datas[i].record
              }
            }
            if ((res.datas[i].type === 4 || res.datas[i].type === 6) && ((res.datas[i].code & (1 << j)) !== 0)) {
              if (d[res.datas[i].Date].Temp[Temp[j]] !== 0) {
                d[res.datas[i].Date][Timehead[j]] += (res.datas[i].record - d[res.datas[i].Date].Temp[Temp[j]])
                // console.log(res.datas[i].record, Temp[j], res.datas[i].code)
                d[res.datas[i].Date].Temp[Temp[j]] = 0
              }
            }
          }
          // console.log(d, res.datas[i].collectorID)
        }
        // console.log(datalist)
        let startTime = new Date(this.selectTime1 + ' 0:0:0').getTime()
        // let gname = ''
        for (let key in datalist) {
          for (let day in datalist[key]) {
            if (this.groupname !== 0) {
              for (let i = 0; i < this.grouplist.length; i++) {
                if (this.groupname === this.grouplist[i].id) {
                  // gname = this.grouplist[i].name
                }
              }
            }
            // console.log(gname, this.groupname, this.grouplist, this.group[key].indexOf(gname), this.group[key])
            // if (this.group[key].indexOf(gname) !== -1) {
            let thisTime = new Date(day).getTime()
            if (thisTime < startTime) {
              continue
            }
            let groupname = this.group[key] === undefined ? '' : this.group[key]
            if (datalist[key][day]['runTotalTime'] === 300 && datalist[key][day]['stopTotalTime'] === 0) {
              datalist[key][day]['runTotalTime'] = 0
              datalist[key][day]['stopTotalTime'] = 86400
            }
            this.datas2.push({
              name: name[key],
              group: groupname,
              date: day,
              runTotalTime: formatSeconds(datalist[key][day]['runTotalTime']),
              stopTime: datalist[key][day]['stopTime'],
              stopTotalTime: formatSeconds(datalist[key][day]['stopTotalTime']),
              error1Time: datalist[key][day]['error1Time'],
              error1TotalTime: formatSeconds(datalist[key][day]['error1TotalTime']),
              error2Time: datalist[key][day]['error2Time'],
              error2TotalTime: formatSeconds(datalist[key][day]['error2TotalTime']),
              error3Time: datalist[key][day]['error3Time'],
              error3TotalTime: formatSeconds(datalist[key][day]['error3TotalTime']),
              error4Time: datalist[key][day]['error4Time'],
              error4TotalTime: formatSeconds(datalist[key][day]['error4TotalTime'])
            })
            // }
          }
        }
      })
      // console.log(this.datas2)
    },
    // dateChange (t) {
    //   this.selectTime = t
    // },
    exportData (type) {
      if (type === 1) {
        this.$refs.table1.exportCsv({
          filename: this.$t('data.Device.output_report'),
          original: false
        })
      } else if (type === 2) {
        this.$refs.table2.exportCsv({
          filename: this.$t('data.Device.run_report'),
          original: false
        })
      }
    },
    collectorSelectChange (v) {
      console.log(v)
      if (v !== 0) {
        this.groupname = 0
      }
    },
    collectorGroupSelectChange (v) {
      if (v !== 0) {
        this.collectorID = 0
      }
    },
    entryTimeChange1 (v) {
      this.selectTime1 = v
    },
    entryTimeChange2 (v) {
      this.selectTime2 = v
    }
  },
  mounted () {
    Api.collector.list().then(res => {
      this.collectorList = res.collectors
    })
    Api.collectorGroup.list().then(res => {
      this.grouplist = res.collectorGroups
      for (let i = 0; i < res.collectorGroups.length; i++) {
        for (let j = 0; j < res.collectorGroups[i].collectors.length; j++) {
          if (this.group[res.collectorGroups[i].collectors[j]] === undefined) {
            this.group[res.collectorGroups[i].collectors[j]] = res.collectorGroups[i].name
          } else {
            this.group[res.collectorGroups[i].collectors[j]] = this.group[res.collectorGroups[i].collectors[j]] + ',' + res.collectorGroups[i].name
          }
        }
      }
    })
    Api.workTime.list().then(res => {
      this.worktime = res.workTimes[0].startTime
      // console.log(this.worktime)
    })
    Api.order.list().then(res => {
      this.orderList = res.orderInfos
    })
  },
  beforeRouteEnter (to, from, next) {
    next()
  }
}
</script>
<style>
.data-page {
  padding: 10px;
  height: 100%;
}
.plan-header>div,.plan-body>div {
  border: #ccc 1px solid;
  padding: 10px;
}
.plan-row .ivu-col {
  padding: 0 10px;
}
.data-pane {
  min-height: 500px;
}
.daterange {
  width: 200px;
}
.collectorSelect {
  width: 100px;
}
</style>





// WEBPACK FOOTER //
// device.vue?67d05913